import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "@/services/i18n/client";
import { route, RouteKeys } from "@/services/routing/routes";
import { useAuth } from "@/lib/auth/use-auth";
import { useAuthActions } from "@/lib/auth/use-auth-actions";
import { CircleUser } from "lucide-react";
import { Button } from "@heycircle/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@heycircle/ui/dropdown-menu";

export function UserMenu() {
  const { user, isLoaded } = useAuth();
  const { logOut } = useAuthActions();
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  if (!isLoaded) return null;

  if (!user) {
    return (
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" asChild>
          <Link to={route(RouteKeys.SIGN_IN)}>{t("nav.signIn")}</Link>
        </Button>
        <Button size="sm" asChild>
          <Link to={route(RouteKeys.SIGN_UP)}>{t("nav.signUp")}</Link>
        </Button>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" data-testid="user-menu-trigger">
          <CircleUser className="h-5 w-5" />
          <span className="sr-only">{t("userMenu.profile")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>
          {user.firstName} {user.lastName}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate(route(RouteKeys.PROFILE))}>
          {t("userMenu.profile")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => logOut()} data-testid="sign-out-button">
          {t("userMenu.signOut")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
